import React, { useState } from 'react';
import { PROJECTS } from '../data';

const finide = PROJECTS.find(p => p.id === 'finide');

export default function PitchDeckOrb() {
  const [open, setOpen] = useState(false);
  const [slideIdx, setSlideIdx] = useState(0);

  if (!finide || !finide.deck) return null;

  return (
    <>
      {/* The Orb — fixed, no label, softly pulsing */}
      <div
        onClick={() => { setOpen(true); setSlideIdx(0); }}
        style={{
          position: 'fixed', bottom: '140px', right: '28px', zIndex: 700,
          width: '14px', height: '14px', borderRadius: '50%',
          background: 'radial-gradient(circle at 35% 35%, #e8c547, #b8960a)',
          cursor: 'crosshair',
          animation: 'orbPulse 3s ease-in-out infinite',
          boxShadow: '0 0 12px rgba(232,197,71,0.3), 0 0 4px rgba(232,197,71,0.6)',
          opacity: 0.7,
          transition: 'opacity 0.3s',
        }}
        onMouseEnter={e => e.currentTarget.style.opacity = '1'}
        onMouseLeave={e => e.currentTarget.style.opacity = '0.7'}
        title=""
      />

      {/* Pitch Deck Modal */}
      {open && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 2400,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(6px)',
        }}
          onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
        >
          <div style={{
            width: 'min(700px, 90vw)', background: '#0e0e0d',
            border: '1px solid rgba(232,197,71,0.2)',
            boxShadow: '0 32px 100px rgba(0,0,0,0.6)',
          }}>
            {/* Header */}
            <div style={{
              padding: '20px 28px', borderBottom: '1px solid rgba(232,197,71,0.1)',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            }}>
              <div>
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: '9px', letterSpacing: '0.25em', color: 'rgba(250,250,248,0.3)', textTransform: 'uppercase', marginBottom: '4px' }}>
                  Investor Mode · Finide
                </div>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: '24px', fontWeight: 600, color: '#fafaf8', letterSpacing: '-0.02em' }}>
                  Pitch Deck
                </div>
              </div>
              <button onClick={() => setOpen(false)} style={{
                fontFamily: 'var(--font-mono)', fontSize: '10px', color: 'rgba(250,250,248,0.3)',
                background: 'none', border: '1px solid rgba(250,250,248,0.1)',
                padding: '6px 14px', cursor: 'pointer', letterSpacing: '0.1em',
              }}>Close</button>
            </div>

            {/* Slide */}
            <div style={{ padding: '48px 36px', minHeight: '240px' }}>
              <div style={{
                fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.25em',
                color: '#e8c547', textTransform: 'uppercase', marginBottom: '20px',
              }}>
                {String(slideIdx + 1).padStart(2, '0')} / {String(finide.deck.length).padStart(2, '0')} · {finide.deck[slideIdx].label}
              </div>
              <div style={{
                fontFamily: 'var(--font-body)', fontSize: '18px', fontWeight: 300,
                color: 'rgba(250,250,248,0.8)', lineHeight: 1.8,
              }}>
                {finide.deck[slideIdx].text}
              </div>
            </div>

            {/* Navigation */}
            <div style={{
              padding: '16px 28px', borderTop: '1px solid rgba(232,197,71,0.1)',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            }}>
              <div style={{ display: 'flex', gap: '6px' }}>
                {finide.deck.map((_, i) => (
                  <div key={i}
                    onClick={() => setSlideIdx(i)}
                    style={{
                      width: i === slideIdx ? '24px' : '8px', height: '3px',
                      background: i === slideIdx ? '#e8c547' : 'rgba(250,250,248,0.15)',
                      cursor: 'pointer', transition: 'all 0.2s',
                    }}
                  />
                ))}
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => setSlideIdx(Math.max(0, slideIdx - 1))}
                  disabled={slideIdx === 0}
                  style={{
                    fontFamily: 'var(--font-mono)', fontSize: '14px',
                    color: slideIdx === 0 ? 'rgba(250,250,248,0.15)' : 'rgba(250,250,248,0.5)',
                    background: 'none', border: '1px solid rgba(250,250,248,0.1)',
                    width: '36px', height: '36px', cursor: slideIdx === 0 ? 'default' : 'pointer',
                  }}
                >←</button>
                <button
                  onClick={() => setSlideIdx(Math.min(finide.deck.length - 1, slideIdx + 1))}
                  disabled={slideIdx === finide.deck.length - 1}
                  style={{
                    fontFamily: 'var(--font-mono)', fontSize: '14px',
                    color: slideIdx === finide.deck.length - 1 ? 'rgba(250,250,248,0.15)' : 'rgba(250,250,248,0.5)',
                    background: 'none', border: '1px solid rgba(250,250,248,0.1)',
                    width: '36px', height: '36px', cursor: slideIdx === finide.deck.length - 1 ? 'default' : 'pointer',
                  }}
                >→</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes orbPulse { 0%,100% { transform: scale(1); box-shadow: 0 0 12px rgba(232,197,71,0.3); } 50% { transform: scale(1.15); box-shadow: 0 0 20px rgba(232,197,71,0.5); } }`}</style>
    </>
  );
}
